import React, { useCallback, useEffect, useState } from "react";
import { api, AppSetting } from "../api/client";
import PageLoader from "../components/PageLoader";

export default function SettingsPage() {
  const [settings, setSettings] = useState<AppSetting[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const data = await api.listSettings();
      setSettings(data);
    } catch (err) {
      console.error("Failed to load settings", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) return <PageLoader />;

  return (
    <div className="page">
      <h2>Настройки приложения</h2>
      <p className="page-description">
        Все настройки приложения, только просмотр. Чтобы изменить значение,
        откройте страницу этой настройки (например, <strong>Функции приложения</strong>,
        {" "}<strong>Минимальная версия</strong>).
      </p>

      <div className="table-wrap">
        <table className="settings-table stack-table settings-list">
          <thead>
            <tr>
              <th>Ключ</th>
              <th>Значение</th>
              <th>Обновлено</th>
            </tr>
          </thead>
          <tbody>
            {settings.length === 0 ? (
              <tr>
                <td colSpan={3} className="empty-cell">
                  Настроек пока нет
                </td>
              </tr>
            ) : (
              settings.map((s) => (
                <tr key={s.key}>
                  <td className="cell-key">
                    <code>{s.key}</code>
                  </td>
                  <td className="cell-value">
                    <span className="value-text">{s.value}</span>
                  </td>
                  <td className="date-cell cell-updated" data-label="Обновлено">
                    {new Date(s.updated_at).toLocaleDateString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
